import {
    TextField,
    IconButton,
    Paper,
    Typography,
    Stack,
    Skeleton,
    Button,
    Modal,
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
    Card,
    Checkbox,Grid,TableContainer

} from "@mui/material";
import 'typeface-inter';
import React, { SetStateAction, useEffect, useState } from "react";
import { useSendMessage } from "../hooks/sendMessage";
import { SendSharp, AccountCircle,SmartToy } from "@mui/icons-material";
import { SampleCard } from "./sample-cards";
import { SearchRecommendations } from "./search-recommendations";
import { backgroundColor } from "../assets/colors";
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import { Properties } from "./properties";
import Chaticonn from "../assets/chatIcon.svg"
import axios from "axios";
import $ from 'jquery';
import chatImg from '../assets/image_34.png'
import FetchChat from '../hooks/fetchChat';
import { SupplierCard } from './supplier-cards';

interface RightPanelProps {
    selectedValue: string;
  }

  interface MessageChat {
    response_id: string;
    isResponse: boolean;
    message: string;
    time: Date;
    results?: any[];
}

export const RightPanel: React.FC<RightPanelProps> = ({ selectedValue }) => {

    const [inputText, setInputText] = useState("");
    const [openDetails, setOpenDetails] = useState(false);
    const [detailsFor, setDetailsFor] = useState(0);
    const [results, setResults] = useState<any[]>([])
    const [compare, setCompare] = useState<number[]>([])
    const { sendMessage, loading, messages, setMessages, sessionId } = useSendMessage();
    const [suppliers, setSuppliers] = useState<any[]>([])
    const [buttonVisible, setButtonVisible] = useState(true);
    const [buttonMsgVisible, setButtonMsgVisible] = useState(false);

    const userDataString = localStorage.getItem('user');
    const userData = userDataString ? JSON.parse(userDataString) : null;
    const userId = userData ? userData.user.user_id : null;

    interface ConversationHistory {
        content: {
          [key: string]: {
            conversation_history: {
              content: string;
              role: string;
              name?: string; // Add name property to check dynamically
            }[];
          };
        }[];
      }

      interface Message {
        isResponse: boolean;
        message: string;
        time: Date;
        results?: any[]; // Adjust the type based on your actual data structure
      }
      
    useEffect(() => {
        if (selectedValue) {
            const fetchChatData = async () => {
                const user_id = encodeURIComponent(selectedValue);
                const apiUrl = `http://34.94.96.59:5050/infindbot/get_history`;
                try {
                    const response = await axios.get<ConversationHistory>(apiUrl, {
                        params: {
                          user_id: userId,
                        },
                        headers: {
                          'Content-Type': 'application/json',
                        },
                      });

                    if (response.data && response.data.content && response.data.content.length > 0) {
                        const filteredMessages = response.data.content
                    .filter(item => Object.keys(item)[0] === selectedValue)
                    .map(item => item[selectedValue].conversation_history);

                    setMessages(() => {
                        const updatedMessages = filteredMessages.flatMap(dynamicValue =>
                            dynamicValue.map((message) => ({
                                isResponse: true,
                                message: message.name === 'product_recommendations' ? '' : (message.content as string),
                                results: message.name === 'product_recommendations' ? JSON.parse(message.content) : undefined,
                                time: new Date(Date.now()),
                                role: message.role,
                            }))
                        );
                    
                        return [ ...updatedMessages];
                    });

                        // response.data.content.forEach((contentItem) => {
                        //   Object.entries(contentItem).forEach(([dynamicKey, dynamicValue]) => {
                        //     if (dynamicValue && dynamicValue.conversation_history) {
                                
                                  
                        //         setMessages(() =>
                        //         dynamicValue.conversation_history.map((message) => ({
                        //             isResponse: true,
                        //             message: message.name === 'product_recommendations' ? '' : (message.content as string),
                        //             results: message.name === 'product_recommendations' ? JSON.parse(message.content) : undefined,
                        //             time: new Date(Date.now()),
                        //             role: message.role,
                        //         })) as Message[]
                        //         );

                        //     } else {
                        //         setMessages([])
                        //       console.error(`Conversation history is undefined for key ${dynamicKey}`);
                        //     }
                        //   });
                        // });
                      } else {
                        setMessages([])
                        console.error('Content is undefined in the response');
                      }
                } catch (error:any) {
                    setMessages([])
            }
          };
            fetchChatData();
        }else{
            setMessages([]);
        }
    }, [selectedValue, setMessages]);

    const selectRecommendation = (value: string) => {
        console.log(value)

        console.log('sgsgsg')
        sendMessage(value);
        sendRequestToApi({
            action: "chats",
            input_name: value,
            user_email: userId,
            sessionId: sessionId
        });
    };

    const userchats = FetchChat(userId);
    useEffect(() => {
    }, [userchats]);

    const onSubmit = () => {
        if (inputText.trim().length > 0) {
            sendMessage(inputText);
            setInputText("");
           // if (res1.status === 200) {
            

            //new code
                sendRequestToApi({
                    action: "chats",
                    input_name: inputText,
                    user_email: userId,
                    sessionId: sessionId
                });
           // }
        }
    };

    const sendRequestToApi = (params: { action?: string; input_name: any; user_email?: any; sessionId?: string | undefined; }) => {
        axios
            .post(
                "https://pssoftgroup.com/demo/infindbot/index.php",
                params
            )
            .then(function (response) {
                if (response.data.success === true) {
                    // const doesSessionExist = userchats.some(chat => chat.session_id);
                    // console.log(doesSessionExist)
                    // console.log(userchats)
                    // const $ul = $(".allchats");
                    // const $p = $(".NoData");
                    // $p.remove();
                    // const dataa = `<li key={index} style="list-style-type: none;"><div style="display: flex; align-items: baseline; gap: 9px;" ><img src=${chatImg} style="position: relative; top: 3px;" /><p style="font-size: 14px; margin-bottom: 2px;">${params.input_name}</p></div></li>`;
                    // $ul.append(dataa);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    useEffect(() => {
        const chatEnd = document.getElementById('chart-end');
        chatEnd && chatEnd.scrollIntoView()
    }, [messages.length])

    useEffect(() => {
        const message = messages[messages.length - 1]
        console.log(message)
        if (message?.results && message?.results.length) {
            setResults(message.results)
            console.log(message.results)
        }
    }, [messages.length])

  


    const comparisonKeys = results?.length > 0 ? Object.keys(results[detailsFor]).filter((key) => key !== 'score' && key !== 'snippet' && key !== 'mapping' && key !== 'alias' && key !== 'abstract') : []
    
    //new code
   
    const [isLiked, setIsLiked] = useState(false);
    const [isDisLiked, setIsDisLiked] = useState(false);
    const handleLike = async (message: string) => {
        console.log(inputText)
  
        let params = {
            action: "checklikes",
            userId: userId,
            input_name: message,
            likeStatus: true,
            dislikeStatus: false
          };

          axios
        .post(
          "https://pssoftgroup.com/demo/infindbot/index.php",
          params
        )
        .then(function (response) {
          if (response.data.error) {
            console.log(response.data.error);
          } else {
           // setIsLiked((prev) => !prev);
            setIsLiked(true);
            setIsDisLiked(false)
            console.log('true');
          }
        })
        .catch(function (error) {
          console.log(error);
        });

    };
    
    const handleDislike = async (message: string) => {
        let params = {
            action: "checklikes",
            userId: userId,
            input_name: message,
            likeStatus: false,
            dislikeStatus: true
        };

        axios.post(
          "https://pssoftgroup.com/demo/infindbot/index.php",
          params
        )
        .then(function (response) {
          if (response.data.error) {
            console.log(response.data.error);
          } else {
           // setIsLiked((prev) => !prev);
            setIsLiked(false);
            setIsDisLiked(true)
            console.log('true');
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    };
    //get suppliers
    const handleGetSuppliers = async () => {
        const apiUrl = 'http://34.94.96.59:5050/infindbot/get_suppliers';
        try {
          const response = await axios.get(apiUrl, {
            headers: {
              'Content-Type': 'application/json',
            },
          });
          const suppliers_data = response.data?.content as any[];
          setSuppliers(suppliers_data)
          setButtonVisible(false);
          setButtonMsgVisible(true)
        } catch (error:any) {
            if (axios.isAxiosError(error)) {
                if (error.response) {
                    console.error('Server responded with:', error.response.status);
                    console.error('Error data:', error.response.data);
                } else if (error.request) {
                    console.error('No response received from server');
                } else {
                    console.error('Error during request setup:', error.message);
                }
            } else {
                console.error('Non-Axios error:', error.message);
            }
        }
    };

    const [selectedEmails, setSelectedEmails] = useState<string[]>([]);
    const handleCheckboxClick = (email: string, isChecked: boolean) => {
        if (isChecked) {
          setSelectedEmails((prev: string[]) => [...prev, email]);
        } else {
          setSelectedEmails((prev: string[]) => prev.filter((prevEmail) => prevEmail !== email));
        }
    };

    const handleBulkEmailClick = () => {
        if (selectedEmails && selectedEmails.length > 0) {
          const emailList = selectedEmails.join(',');
          const mailtoLink = `mailto:${emailList}`;
          window.location.href = mailtoLink;
        } else {
          console.log("No emails selected.");
        }
    };
      
    return (
        <Stack
        direction="column"
        spacing="20px"
        paddingBottom={"20px"}
        paddingLeft={"20px"}
        paddingRight={"20px"}
      >
        <Paper
            elevation={3}
            sx={{ width: "100%", height: "90%", borderRadius: "20px", margin:"20px auto" }}
        >
         
            <Stack
                direction={"column"}
                // gap={"5px"}
                padding={"20px"}
                //style={{ height:"440px", overflowY: "auto" }} 
                spacing="20px"
            >
                <Stack
                    direction={"column"}
                    spacing="20px"
                    id="chat-containor"
                    style={{ background: "white" }}
                >

                    {messages.map((message, idx) => (
                        
                        <Stack direction="column" key={idx} spacing="10px">
                           <Stack
                                direction="row"
                                spacing="10px"
                                justifyContent={"space-between"}
                                alignItems="baseline"
                            > 
                                <div className="left" style={{display:"flex", gap: "10px", alignItems:"center"}} >
                                {message.isResponse ? <img src={Chaticonn}  alt="version-icon" width={"20px"} /> : <AccountCircle />}
                                <Typography variant="body1" fontWeight={"bold"}>
                                    {message.isResponse ? "Patbio.ai" : "You"}
                                </Typography>
                                <Typography variant="subtitle2">
                                    {message.time.toLocaleTimeString()}
                                </Typography>
                                </div>
                                <div className="right" style={{display:"flex", gap: "8px", alignItems:"center"}}>
                                {
                                    message.isResponse ? (
                                        <>
                                        {isLiked ? (
                                            <Typography>
                                            <ThumbUpOffAltIcon />
                                            </Typography>
                                        ) : (
                                            <>
                                            <Typography>
                                                <ThumbUpOffAltIcon onClick={() => handleLike(message.message)} />
                                            </Typography>
                                            <Typography>
                                                <ThumbDownAltIcon onClick={() => handleDislike(message.message)} />
                                            </Typography>
                                            </>
                                        )}
                                     </>
                                    ) : (
                                        <Typography></Typography>
                                    )
                                    }
                               </div>
                            </Stack>
                            <Typography variant="body1">{message.message}</Typography>
                            {message?.results && message?.results.length > 0 && (
                                 <Stack
                                 direction={"row"}
                                 spacing="20px"
                                 //padding='20px'
                                 // gap={"20px"}
                                bgcolor={"#cceeff"}
                                 flexWrap= {"wrap"}
                                 justifyContent={"center"}
                                 style={{overflowY: "auto", maxHeight: "440px" }}
                             >
                                <Grid container spacing={{ xs: 2, md: 3 }} >
                                    {message.results.map((result, idx) => (
                                    <Grid item xs={12} sm={4} md={4} style={{padding:"10px"}} key={idx}>
                                    <SampleCard key={idx} result={result} setOpenDetails={setOpenDetails} resultPosition={idx} setResultsFor={setDetailsFor} />
                                    </Grid>
                                    ))}
                                </Grid>
                                    {/* {message.results.map((result, idx) => (
                                        <SampleCard key={idx} result={result} setOpenDetails={setOpenDetails} resultPosition={idx} setResultsFor={setDetailsFor} />
                                    ))} */}
                                </Stack>
                            )}
                        </Stack>
                    ))}
                    <div id='chart-end'></div>
                    {loading && (
                        <Stack
                            direction="row"
                            spacing="10px"
                            justifyContent={"start"}
                            alignItems="end"
                        >
                             <img src={Chaticonn}  alt="version-icon" width={"20px"} />
                            <Typography variant="body1" fontWeight={"bold"}>
                                Patbio.ai
                            </Typography>
                            <Skeleton>
                                <Typography variant="body1" fontWeight={"bold"}>
                                    Fetching response
                                </Typography>
                            </Skeleton>
                        </Stack>
                    )}
                </Stack>
                {buttonMsgVisible && (
                <Stack direction="column" key={1} spacing="10px">
                <Stack
                    direction="row"
                    spacing="10px"
                    justifyContent={"space-between"}
                    alignItems="baseline"
                > 
                    <div className="left" style={{display:"flex", gap: "10px", alignItems:"center"}} >
                    <img src={Chaticonn}  alt="version-icon" width={"20px"} />
                    <Typography variant="body1" fontWeight={"bold"}>
                    Patbio.ai
                    </Typography>
                    
                    </div>
                    </Stack>
                    <Typography variant="body1">Here are the Suppliers that sell/distribute such motors:</Typography>
                    <Grid container spacing={{ xs: 2, md: 3 }} >
                        {suppliers.map((supplier, idx) => (
                        <Grid item xs={12} sm={4} md={4} style={{padding:"10px"}} key={idx}>
                            <SupplierCard key={idx} supplier={supplier}  onCheckboxClick={handleCheckboxClick}/>
                        </Grid>
                        ))}
                    </Grid>
                {buttonMsgVisible && (
                    <Button variant="outlined" onClick={handleBulkEmailClick} style={{ fontFamily:"inter", fontWeight:400, color:"#000", fontSize:"16px", border:"none", background:"#D9D9D9", margin: "12px auto", display: "block"   }}>
                    Bulk Message
                    </Button>
                )}
                </Stack>
                )}
                {/* {comparisonKeys.length != 0 && buttonVisible && (
                    <Button variant="outlined" onClick={handleGetSuppliers} style={{ fontFamily:"inter", fontWeight:400, color:"#000", fontSize:"16px", border:"none", background:"#D9D9D9", margin: "12px auto", display: "block"   }}>
                    See Suppliers
                    </Button>
                )} */}

                {messages.length === 0 && (
                    <SearchRecommendations onClick={selectRecommendation} />
                )}
                <TextField
                    id="input-with-icon-textfield"
                    label="Ask a patent question here!"
                    multiline
                    value={inputText}
                    onChange={(e) => setInputText(e.target.value)}
                    disabled={loading}
                    InputProps={{
                        sx: {
                            borderRadius: "20px",
                        },
                        endAdornment: (
                            <IconButton onClick={onSubmit}>
                                <SendSharp htmlColor={backgroundColor} />
                            </IconButton>
                        ),
                    }}
                    variant="outlined"
                    fullWidth
                />
            </Stack>
            {results.length > 0 && 
            <Modal
                open={openDetails}
                onClose={() => { setOpenDetails(false); setCompare([]); setDetailsFor(0) }}
                disablePortal={true}
            >
                <Stack
                    direction={"column"}
                    spacing="5px"
                    borderRadius={"20px"}
                    padding={"20px"}
                    style={{
                        maxWidth: "70vw",
                        minHeight: '90vh',
                        maxHeight: '90vh',
                        top: "50%",
                        left: "50%",
                        position: "absolute",
                        transform: "translate(-50%, -50%)",
                        background: "white",
                        display: 'flex'
                    }}
                >
                   <Grid container spacing={2} width={"100%"} direction="row" alignItems="flex-start" bgcolor="#fff"  style={{ overflowY: 'auto', minHeight: "90vh", maxHeight: "90vh" }}>
              <Grid item lg={6} xs={12} sm={6} padding={"10px"}>
              <Stack>
              <Properties keyString="Patent name" value={results[detailsFor]?.['title'] ?? '-'}/>
                    <Properties keyString="Patent Number" value={results[detailsFor]?.['id'] ?? '-'}/>
                    <Properties keyString="Description" value={results[detailsFor]?.['abstract'] ?? '-'}/>
                    <Properties keyString="Owner" value={results[detailsFor]?.['owner'] ?? '-'}/>
                    <Properties keyString="Inventors" value={results[detailsFor]?.['inventors'] ?? '-'}/>
                    <Properties keyString="CPC subclass" value={results[detailsFor]?.['index'] ?? '-'}/>
                    {results[detailsFor] && results[detailsFor].website && 
                        <Stack style={{ justifyContent:"space-between", flexDirection:"row", gap:"20px" }}>
                    <Button
                        variant="outlined"
                        onClick={() => window.open(results[detailsFor].website)}
                        style={{ margin: "20px 0px 20px 0px",  width:"100%" }}
                    >
                        Visit website
                    </Button>
                    {/* <Button
                        variant="outlined"
                        style={{ margin: "20px 0px 20px 0px", width:"100%" }}
                    >
                        Connect/Chat
                    </Button> */}
                    </Stack>
                    }
              </Stack>
              </Grid>
              <Grid item lg={6} xs={12} sm={6} padding={"10px"}>
              
                    <Stack>
                    <Typography variant="subtitle2" style={{margin:"5px"}}>Select other search results to compare</Typography>
                        {results.filter((_, idx) => idx !== detailsFor).length > 0 && (
                              <Paper elevation={3}  style={{ height: '35vh', overflowY:"scroll" }}>
                            <Grid container spacing={2} width={"100%"} direction="row" alignItems="flex-start" bgcolor="#cceeff"  style={{ overflowY: 'auto', margin:"0px" }}>
                                
                                {results.map((result, idx) => {
                                    return idx !== detailsFor ? 
                                    <Grid item lg={6} xs={12} sm={6} padding={"10px"} paddingLeft={"0px"}>
									<Card sx={{ maxHeight: "200px" }} elevation={1}>
                                        <Stack key={idx} direction='column' padding='10px'>
                                            <Properties keyString="Patent Title" value={result?.['title'] ? result['title'].toUpperCase() : '-'} />
                                            <Properties keyString="Owner" value={result?.['owner'] ?? '-'} />
                                            <Properties keyString="Publication Date" value={result?.['publication_date'] ?? '-'} />
                                            {<Checkbox size="small" onChange={(_, value) => setCompare(prev => value ? [...prev, idx] : prev.filter((i) => i !== idx))} style={{height:"15px", padding:"0px", borderRadius:"0px", width:"16px"}} /> }
                                        </Stack>
                                    </Card> 
                                    </Grid>
                                    : <></>
                                }
                                )}
                                
                            </Grid>
                            </Paper>
                        )}
                    </Stack>
              </Grid>
              
              <Stack style={{
                        overflow: 'auto'
                    }}>
                    <TableContainer component={Paper}>
                      <Table sx={{ border:"1px solid" }} aria-label="customized table">
                            <TableHead>
                                <TableRow key={'table header'}>
                                    {comparisonKeys.map((key) => (

                                        <TableCell align="center"><Typography variant="body1">{key}</Typography></TableCell>
                                    )
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow key={'selected-item'}>
                                    {comparisonKeys.map((key, idx) => (
                                        <TableCell align="center"><Typography variant="body1">{results?.[detailsFor]?.[key] ?? '-'}</Typography></TableCell>
                                    )
                                    )}
                                </TableRow>
                                {compare.map((v) => <TableRow key={`compare-${v}`}>
                                    {comparisonKeys.map((key, idx) => (
                                        <TableCell align="center"><Typography variant="body1">{results?.[v]?.[key] ?? '-'}</Typography></TableCell>
                                    )
                                    )}
                                </TableRow>)}
                            </TableBody>
                        </Table>
                        </TableContainer>
                    </Stack>
            </Grid>
                  
                 
                </Stack>
            </Modal>
            }
        </Paper>
        </Stack>
    );
};
